(() => {
  const setupFlavours = (section) => {
    if (section.dataset.flavourStateReady) return;
    section.dataset.flavourStateReady = 'true';
    const get = (selector) => section.querySelector(selector);
    const eyebrow = get('.brio-flavours-master__eyebrow');
    const title = get('#brio-flavours-title');
    const description = get('.brio-flavours-master__description');
    const traits = get('.brio-flavours-master__traits');
    const cta = get('.brio-flavours-master__cta');
    const notes = get('.brio-flavours-master__notes');
    const noteItems = [...notes.querySelectorAll(':scope > span')];
    const notesLink = notes.querySelector(':scope > a');
    const navLinks = [...section.querySelectorAll('[data-brio-flavour]')];
    const mobileButtons = [...section.querySelectorAll('[data-brio-mobile-flavour]')];
    const flavourOrder = ['original', 'ginger', 'strawberry', 'mint'];
    const noteData = (item) => ({ image: item.querySelector('img').getAttribute('src'), title: item.querySelector('b').textContent, description: item.querySelector('small').textContent });
    const original = { eyebrow: eyebrow.innerHTML, title: title.innerHTML, description: description.innerHTML, cta: cta.getAttribute('href'), notesLabel: notes.getAttribute('aria-label'), notes: noteItems.map(noteData), notesLink: notesLink.getAttribute('href'), notesLinkLabel: notesLink.getAttribute('aria-label') };
    const ginger = {
      eyebrow: '<b>02</b><span>GINGEMBRE</span>', title: 'DU CARACTÈRE<br><em>NATUREL.</em>',
      description: 'Le peps du gingembre, la douceur du maté. Une énergie vive et pleine de caractère.<small>Épicé · Vif · Rafraîchissant</small>',
      cta: section.dataset.gingerUrl,
      notesLabel: 'Les sensations Gingembre',
      notes: [
        { image: section.dataset.gingerNoteGinger, title: 'GINGEMBRE FRAIS', description: 'Un ingrédient naturel au caractère affirmé.' },
        { image: section.dataset.gingerNoteMate, title: 'YERBA MATÉ BIO', description: 'Une plante naturellement énergisante.' },
        { image: section.dataset.gingerNoteSparkling, title: 'PÉTILLANTE', description: 'Une fraîcheur dès la première gorgée.' },
      ],
      notesLink: section.dataset.gingerUrl, notesLinkLabel: 'En savoir plus sur Gingembre',
    };
    const strawberry = {
      eyebrow: '<b>03</b><span>FRAISE &amp; CITRON VERT</span>', title: 'UNE ÉNERGIE<br><em>FRUITÉE.</em>',
      description: 'La fraise rencontre le citron vert. Une énergie fruitée et rafraîchissante.<small>FRUITÉ · ACIDULÉ · PÉTILLANT</small>',
      cta: section.dataset.strawberryUrl,
      notesLabel: 'Les sensations Fraise et Citron vert',
      notes: [
        { image: section.dataset.strawberryNoteFruit, title: 'FRAISE NATURELLE', description: 'Des arômes fruités et authentiques.' },
        { image: section.dataset.strawberryNoteLime, title: 'CITRON VERT', description: 'Une touche de fraîcheur intense.' },
        { image: section.dataset.strawberryNoteMate, title: 'YERBA MATÉ BIO', description: 'Une plante naturellement énergisante.' },
      ],
      notesLink: section.dataset.strawberryUrl, notesLinkLabel: 'En savoir plus sur Fraise et Citron vert',
    };
    const mint = {
      eyebrow: '<b>04</b><span>MENTHE &amp; CITRON</span>', title: 'FRAIS.<br><em>VIVIFIANT.</em>',
      description: 'La menthe et le citron pour une fraîcheur vive et légère.<small>FRAIS · MENTHOLÉ · TONIQUE</small>',
      cta: section.dataset.mintUrl,
      notesLabel: 'Les sensations Menthe et Citron',
      notes: [
        { image: section.dataset.mintNoteMint, title: 'MENTHE NATURELLE', description: 'Une fraîcheur intense et équilibrée.' },
        { image: section.dataset.mintNoteLemon, title: 'CITRON JAUNE', description: 'Une touche acidulée et vivifiante.' },
        { image: section.dataset.mintNoteMate, title: 'YERBA MATÉ BIO', description: 'Une plante naturellement énergisante.' },
      ],
      notesLink: section.dataset.mintUrl, notesLinkLabel: 'En savoir plus sur Menthe et Citron',
    };
    const fromLocation = () => {
      const requested = new URLSearchParams(location.search).get('brio_flavour');
      return ['ginger', 'strawberry', 'mint'].includes(requested) ? requested : 'original';
    };
    let activeFlavour = fromLocation();
    let scrollMotion = null;
    let mobileScrollMotion = null;
    const setNavActive = (flavour) => {
      activeFlavour = flavour;
      const header = document.querySelector('.brio-banner-header');
      if (header) header.dataset.brioActiveFlavour = flavour;
      navLinks.forEach((link) => {
        const item = link.closest('li');
        const active = link.dataset.brioFlavour === flavour;
        item.classList.toggle('is-active', active);
        if (active) item.setAttribute('aria-current', 'true'); else item.removeAttribute('aria-current');
      });
      mobileButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.brioMobileFlavour === flavour));
      });
    };
    const show = (flavour) => {
      const content = flavour === 'ginger' ? ginger : flavour === 'strawberry' ? strawberry : flavour === 'mint' ? mint : original;
      section.classList.toggle('is-ginger', flavour === 'ginger');
      section.classList.toggle('is-strawberry', flavour === 'strawberry');
      section.classList.toggle('is-mint', flavour === 'mint');
      eyebrow.innerHTML = content.eyebrow;
      title.innerHTML = flavour === 'mint' && window.matchMedia('(min-width: 851px)').matches
        ? 'UNE FRAÎCHEUR<br><em>REVITALISANTE.</em>'
        : content.title;
      description.innerHTML = content.description;
      cta.setAttribute('href', content.cta);
      notes.setAttribute('aria-label', content.notesLabel);
      noteItems.forEach((item, index) => {
        const image = item.querySelector('img');
        image.setAttribute('src', content.notes[index].image);
        item.querySelector('b').textContent = content.notes[index].title;
        item.querySelector('small').textContent = content.notes[index].description;
      });
      const gingerImage = noteItems[0].querySelector('img');
      const gingerFrame = noteItems[0].querySelector('.brio-flavours-master__ginger-note-frame');
      if (flavour === 'ginger' && !gingerFrame) {
        const frame = document.createElement('span');
        frame.className = 'brio-flavours-master__ginger-note-frame';
        gingerImage.before(frame);
        frame.append(gingerImage);
      } else if (flavour !== 'ginger' && gingerFrame) {
        gingerFrame.before(gingerImage);
        gingerFrame.remove();
      }
      notesLink.setAttribute('href', content.notesLink);
      notesLink.setAttribute('aria-label', content.notesLinkLabel);
      setNavActive(flavour);
      if (flavour !== 'original') {
        section.classList.add('is-can-motion-visible');
        notes.classList.add('is-notes-motion-visible');
      }
    };

    const setupScrollMotion = () => {
      if (!window.gsap || !window.ScrollTrigger) return;
      const { gsap, ScrollTrigger } = window;
      gsap.registerPlugin(ScrollTrigger);
      const media = gsap.matchMedia();
      media.add('(min-width: 851px) and (prefers-reduced-motion: no-preference)', () => {
        const scene = get('.brio-flavours-master__scene');
        const landscape = get('.brio-flavours-master__landscape');
        const haze = get('.brio-flavours-master__haze');
        const copy = get('.brio-flavours-master__copy');
        const mateProduct = get('.brio-flavours-master__product');
        const mateCan = get('.brio-flavours-master__can');
        const mateShadow = get('.brio-flavours-master__contact-shadow');
        const gingerProduct = get('.brio-flavours-master__ginger-product');
        const strawberryProduct = get('.brio-flavours-master__strawberry-product');
        const mintProduct = get('.brio-flavours-master__mint-product');
        const gingerAside = get('.brio-flavours-master__ginger-aside');
        const pack = get('.brio-flavours-master__pack');
        const packLandscape = get('.brio-flavours-master__pack-landscape');
        const packBoxes = [...section.querySelectorAll('.brio-flavours-master__pack-box')];
        const packCansGroup = get('.brio-flavours-master__pack-cans');
        const packCopy = get('.brio-flavours-master__pack-copy');
        const packCans = ['original', 'ginger', 'strawberry', 'mint'].map((flavour) => get(`.brio-flavours-master__pack-can--${flavour}`));
        const [packOriginal, packGinger, packStrawberry, packMint] = packCans;
        const flavourNav = get('.brio-flavours-master__nav');
        if (!scene || !landscape || !copy || !mateProduct || !mateCan || !gingerProduct || !strawberryProduct || !mintProduct) return;

        // Create the second layer from the approved manual Ginger state.
        show('ginger');
        const gingerCopy = copy.cloneNode(true);
        gingerCopy.classList.add('brio-flavours-master__copy--scroll-ginger');
        gingerCopy.querySelector('#brio-flavours-title')?.removeAttribute('id');
        gingerCopy.querySelector('template')?.remove();
        const gingerNotes = notes.cloneNode(true);
        gingerNotes.classList.add('brio-flavours-master__notes--scroll-ginger');
        gingerNotes.classList.remove('is-notes-motion-ready', 'is-notes-motion-visible');
        show('strawberry');
        const strawberryCopy = copy.cloneNode(true);
        strawberryCopy.classList.add('brio-flavours-master__copy--scroll-strawberry');
        strawberryCopy.querySelector('#brio-flavours-title')?.removeAttribute('id');
        strawberryCopy.querySelectorAll('template').forEach((template) => template.remove());
        const strawberryNotes = notes.cloneNode(true);
        strawberryNotes.classList.add('brio-flavours-master__notes--scroll-strawberry');
        strawberryNotes.classList.remove('is-notes-motion-ready', 'is-notes-motion-visible');
        show('mint');
        const mintCopy = copy.cloneNode(true);
        mintCopy.classList.add('brio-flavours-master__copy--scroll-mint');
        mintCopy.querySelector('#brio-flavours-title')?.removeAttribute('id');
        mintCopy.querySelectorAll('template').forEach((template) => template.remove());
        const mintNotes = notes.cloneNode(true);
        mintNotes.classList.add('brio-flavours-master__notes--scroll-mint');
        mintNotes.classList.remove('is-notes-motion-ready', 'is-notes-motion-visible');
        show('original');

        const gingerBackdrop = document.createElement('div');
        gingerBackdrop.className = 'brio-flavours-master__scroll-ginger-backdrop';
        gingerBackdrop.setAttribute('aria-hidden', 'true');
        const gingerLandscape = document.createElement('div');
        gingerLandscape.className = 'brio-flavours-master__scroll-ginger-landscape';
        gingerLandscape.setAttribute('aria-hidden', 'true');
        const gingerHaze = document.createElement('div');
        gingerHaze.className = 'brio-flavours-master__scroll-ginger-haze';
        gingerHaze.setAttribute('aria-hidden', 'true');
        const strawberryBackdrop = document.createElement('div');
        strawberryBackdrop.className = 'brio-flavours-master__scroll-strawberry-backdrop';
        strawberryBackdrop.setAttribute('aria-hidden', 'true');
        const strawberryLandscape = document.createElement('div');
        strawberryLandscape.className = 'brio-flavours-master__scroll-strawberry-landscape';
        strawberryLandscape.setAttribute('aria-hidden', 'true');
        const strawberryHaze = document.createElement('div');
        strawberryHaze.className = 'brio-flavours-master__scroll-strawberry-haze';
        strawberryHaze.setAttribute('aria-hidden', 'true');
        const mintBackdrop = document.createElement('div');
        mintBackdrop.className = 'brio-flavours-master__scroll-mint-backdrop';
        mintBackdrop.setAttribute('aria-hidden', 'true');
        const mintLandscape = document.createElement('div');
        mintLandscape.className = 'brio-flavours-master__scroll-mint-landscape';
        mintLandscape.setAttribute('aria-hidden', 'true');
        const mintHaze = document.createElement('div');
        mintHaze.className = 'brio-flavours-master__scroll-mint-haze';
        mintHaze.setAttribute('aria-hidden', 'true');
        scene.append(gingerBackdrop, gingerLandscape, gingerHaze, strawberryBackdrop, strawberryLandscape, strawberryHaze, mintBackdrop, mintLandscape, mintHaze, gingerCopy, strawberryCopy, mintCopy);
        section.append(gingerNotes, strawberryNotes, mintNotes);
        section.classList.add('is-scroll-transition');

        const placeOverCopy = () => {
          const sceneBox = scene.getBoundingClientRect();
          const copyBox = copy.getBoundingClientRect();
          const mateCanBox = mateCan.getBoundingClientRect();
          scene.style.setProperty('--brio-ginger-can-left', `${mateCanBox.left + mateCanBox.width / 2 - sceneBox.left}px`);
          [gingerCopy, strawberryCopy, mintCopy].forEach((overlay) => {
            overlay.style.left = `${copyBox.left - sceneBox.left}px`;
            overlay.style.top = `${copyBox.top - sceneBox.top}px`;
            overlay.style.width = `${copyBox.width}px`;
          });
          gingerNotes.style.height = `${notes.getBoundingClientRect().height}px`;
          strawberryNotes.style.height = gingerNotes.style.height;
          mintNotes.style.height = gingerNotes.style.height;
          const mintImage = mintProduct.querySelector('img');
          if (mintImage && packMint && !scrollMotion) {
            const mintBox = mintImage.getBoundingClientRect();
            const sectionBox = section.getBoundingClientRect();
            gsap.set(packMint, {
              left: mintBox.left + mintBox.width / 2 - sectionBox.left,
              top: mintBox.top - sectionBox.top,
              height: mintBox.height,
            });
          }
        };
        placeOverCopy();

        const mateCopyParts = [eyebrow, title, description, traits, cta];
        const mateNoteParts = [...notes.children];
        const gingerEyebrow = gingerCopy.querySelector('.brio-flavours-master__eyebrow');
        const gingerTitle = gingerCopy.querySelector('h2');
        const gingerDescription = gingerCopy.querySelector('.brio-flavours-master__description');
        const gingerTraits = gingerCopy.querySelector('.brio-flavours-master__traits');
        const gingerCta = gingerCopy.querySelector('.brio-flavours-master__cta');
        const gingerNoteParts = [...gingerNotes.children];
        const strawberryEyebrow = strawberryCopy.querySelector('.brio-flavours-master__eyebrow');
        const strawberryTitle = strawberryCopy.querySelector('h2');
        const strawberryDescription = strawberryCopy.querySelector('.brio-flavours-master__description');
        const strawberryTraits = strawberryCopy.querySelector('.brio-flavours-master__traits');
        const strawberryCta = strawberryCopy.querySelector('.brio-flavours-master__cta');
        const strawberryNoteParts = [...strawberryNotes.children];
        const mintEyebrow = mintCopy.querySelector('.brio-flavours-master__eyebrow');
        const mintTitle = mintCopy.querySelector('h2');
        const mintDescription = mintCopy.querySelector('.brio-flavours-master__description');
        const mintTraits = mintCopy.querySelector('.brio-flavours-master__traits');
        const mintCta = mintCopy.querySelector('.brio-flavours-master__cta');
        const mintNoteParts = [...mintNotes.children];
        gsap.set([gingerBackdrop, gingerLandscape, gingerHaze, gingerAside, strawberryBackdrop, strawberryLandscape, strawberryHaze, mintBackdrop, mintLandscape, mintHaze], { autoAlpha: 0 });
        const mateCanFilter = getComputedStyle(mateCan).filter;
        const mateCanWithBlur = (blur) => `${mateCanFilter === 'none' ? '' : `${mateCanFilter} `}blur(${blur}px)`;
        gsap.set(mateCan, { filter: mateCanWithBlur(0) });
        gsap.set(gingerProduct, { autoAlpha: 0, y: 30, scale: .96, filter: 'blur(4px)', transformOrigin: 'var(--brio-ginger-can-left) 85%' });
        gsap.set(strawberryProduct, { autoAlpha: 0, y: 30, scale: .96, filter: 'blur(4px)', transformOrigin: 'var(--brio-ginger-can-left) 85%' });
        gsap.set(mintProduct, { autoAlpha: 0, y: 30, scale: .96, filter: 'blur(4px)', transformOrigin: 'var(--brio-ginger-can-left) 85%' });
        gsap.set([gingerEyebrow, gingerDescription, gingerTraits, gingerCta], { autoAlpha: 0, y: 12 });
        gsap.set(gingerTitle, { autoAlpha: 0, y: 14, clipPath: 'inset(0 0 100% 0)' });
        gsap.set(gingerNotes, { autoAlpha: 0 });
        gsap.set(gingerNoteParts, { autoAlpha: 0, y: 12, scale: .98 });
        gsap.set([strawberryEyebrow, strawberryDescription, strawberryTraits, strawberryCta], { autoAlpha: 0, y: 12 });
        gsap.set(strawberryTitle, { autoAlpha: 0, y: 14, clipPath: 'inset(0 0 100% 0)' });
        gsap.set(strawberryNotes, { autoAlpha: 0 });
        gsap.set(strawberryNoteParts, { autoAlpha: 0, y: 12, scale: .98 });
        gsap.set([mintEyebrow, mintDescription, mintTraits, mintCta], { autoAlpha: 0, y: 12 });
        gsap.set(mintTitle, { autoAlpha: 0, y: 14, clipPath: 'inset(0 0 100% 0)' });
        gsap.set(mintNotes, { autoAlpha: 0 });
        gsap.set(mintNoteParts, { autoAlpha: 0, y: 12, scale: .98 });
        gsap.set(packLandscape, { autoAlpha: 0 });
        gsap.set(packBoxes, { autoAlpha: 0, y: 260 });
        gsap.set(packCopy, { autoAlpha: 0 });
        gsap.set([...packCopy.children], { autoAlpha: 0, y: 18 });
        gsap.set(packCans, { autoAlpha: 0, xPercent: -50, rotation: 0 });
        gsap.set(packMint, { rotation: 8 });
        gsap.set([packOriginal, packGinger, packStrawberry], { y: 36, scale: .97, filter: 'blur(3px)' });
        gingerCopy.setAttribute('aria-hidden', 'true');
        gingerNotes.setAttribute('aria-hidden', 'true');
        strawberryCopy.setAttribute('aria-hidden', 'true');
        strawberryNotes.setAttribute('aria-hidden', 'true');
        mintCopy.setAttribute('aria-hidden', 'true');
        mintNotes.setAttribute('aria-hidden', 'true');
        gingerCopy.style.pointerEvents = 'none';
        gingerNotes.style.pointerEvents = 'none';
        strawberryCopy.style.pointerEvents = 'none';
        strawberryNotes.style.pointerEvents = 'none';
        mintCopy.style.pointerEvents = 'none';
        mintNotes.style.pointerEvents = 'none';
        pack.setAttribute('aria-hidden', 'true');

        const sceneDuration = 5.23;
        const progressDriver = { value: 0 };
        const timeline = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            trigger: section,
            start: 'top top',
            end: () => `+=${Math.round(window.innerHeight * 6)}`,
            pin: true,
            pinSpacing: true,
            // Refresh this upstream pin before the lifestyle scene below it.
            refreshPriority: 1,
            scrub: 0.45,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            onRefresh: placeOverCopy,
            onUpdate: (self) => {
              const sceneTime = self.progress * sceneDuration;
              const flavour = sceneTime >= 2.8 ? 'mint' : sceneTime >= 1.8 ? 'strawberry' : sceneTime >= .81 ? 'ginger' : 'original';
              if (flavour !== activeFlavour) setNavActive(flavour);
              const gingerAccessible = sceneTime >= .65 && sceneTime < 1.65;
              const strawberryAccessible = sceneTime >= 1.65 && sceneTime < 2.65;
              const mintAccessible = sceneTime >= 2.65 && sceneTime < 3.35;
              const packAccessible = sceneTime >= 4.35;
              gingerCopy.setAttribute('aria-hidden', String(!gingerAccessible));
              gingerNotes.setAttribute('aria-hidden', String(!gingerAccessible));
              strawberryCopy.setAttribute('aria-hidden', String(!strawberryAccessible));
              strawberryNotes.setAttribute('aria-hidden', String(!strawberryAccessible));
              mintCopy.setAttribute('aria-hidden', String(!mintAccessible));
              mintNotes.setAttribute('aria-hidden', String(!mintAccessible));
              pack.setAttribute('aria-hidden', String(!packAccessible));
              packCopy.style.pointerEvents = packAccessible ? 'auto' : 'none';
              copy.setAttribute('aria-hidden', String(gingerAccessible || strawberryAccessible || mintAccessible));
              notes.setAttribute('aria-hidden', String(gingerAccessible || strawberryAccessible || mintAccessible));
              gingerCopy.style.pointerEvents = sceneTime >= .8 && sceneTime < 1.5 ? 'auto' : 'none';
              gingerNotes.style.pointerEvents = sceneTime >= .8 && sceneTime < 1.5 ? 'auto' : 'none';
              strawberryCopy.style.pointerEvents = sceneTime >= 1.8 && sceneTime < 2.5 ? 'auto' : 'none';
              strawberryNotes.style.pointerEvents = sceneTime >= 1.8 && sceneTime < 2.5 ? 'auto' : 'none';
              mintCopy.style.pointerEvents = sceneTime >= 2.8 && sceneTime < 3.25 ? 'auto' : 'none';
              mintNotes.style.pointerEvents = sceneTime >= 2.8 && sceneTime < 3.25 ? 'auto' : 'none';
              flavourNav.style.pointerEvents = sceneTime >= 3.35 ? 'none' : 'auto';
              copy.style.pointerEvents = sceneTime >= .55 ? 'none' : 'auto';
              notes.style.pointerEvents = sceneTime >= .75 ? 'none' : 'auto';
            },
          },
        });
        timeline.to(progressDriver, { value: sceneDuration, duration: sceneDuration }, 0);
        timeline.to(mateCopyParts, { autoAlpha: 0, y: -12, duration: .12, stagger: .018 }, .36);
        if (mateShadow) timeline.to(mateShadow, { autoAlpha: 0, duration: .19 }, .32);
        timeline.to(mateCan, { autoAlpha: 0, y: -20, scale: .98, filter: mateCanWithBlur(2), duration: .3 }, .32);
        timeline.to(mateNoteParts, { autoAlpha: 0, y: -10, duration: .14, stagger: .025 }, .47);
        timeline.to(haze, { autoAlpha: 0, duration: .35 }, .38);
        timeline.to(gingerBackdrop, { autoAlpha: 1, duration: .36 }, .42);
        timeline.to(gingerLandscape, { autoAlpha: 1, duration: .36 }, .42);
        timeline.to(gingerHaze, { autoAlpha: 1, duration: .3 }, .47);
        timeline.to(landscape, { autoAlpha: 0, duration: .3 }, .48);
        timeline.to(gingerProduct, { autoAlpha: 1, duration: .28 }, .42);
        timeline.to(gingerProduct, { y: 0, scale: 1, filter: 'blur(0px)', duration: .42 }, .42);
        timeline.to(gingerEyebrow, { autoAlpha: 1, y: 0, duration: .08 }, .49);
        timeline.to(gingerTitle, { autoAlpha: 1, duration: .08 }, .5);
        timeline.to(gingerTitle, { y: 0, clipPath: 'inset(0 0 0% 0)', duration: .13 }, .5);
        timeline.to(gingerDescription, { autoAlpha: 1, y: 0, duration: .12 }, .57);
        timeline.to(gingerTraits, { autoAlpha: 1, y: 0, duration: .1 }, .63);
        timeline.to(gingerCta, { autoAlpha: 1, y: 0, duration: .1 }, .68);
        timeline.to(gingerAside, { autoAlpha: 1, duration: .14 }, .64);
        timeline.to(gingerNotes, { autoAlpha: 1, duration: .11 }, .53);
        timeline.to(gingerNoteParts, { autoAlpha: 1, y: 0, scale: 1, duration: .1, stagger: .025 }, .6);
        timeline.to([gingerEyebrow, gingerTitle, gingerDescription, gingerTraits, gingerCta], { autoAlpha: 0, y: -12, duration: .12, stagger: .018 }, 1.35);
        timeline.to(gingerProduct, { autoAlpha: 0, y: -20, scale: .98, filter: 'blur(2px)', duration: .3 }, 1.32);
        timeline.to(gingerAside, { autoAlpha: 0, duration: .13 }, 1.35);
        timeline.to(gingerNoteParts, { autoAlpha: 0, y: -10, duration: .14, stagger: .025 }, 1.47);
        timeline.to(gingerNotes, { autoAlpha: 0, duration: .13 }, 1.56);
        timeline.to(strawberryBackdrop, { autoAlpha: 1, duration: .38 }, 1.41);
        timeline.to(strawberryLandscape, { autoAlpha: 1, duration: .38 }, 1.41);
        timeline.to(strawberryHaze, { autoAlpha: 1, duration: .32 }, 1.44);
        timeline.to(gingerBackdrop, { autoAlpha: 0, duration: .34 }, 1.5);
        timeline.to(gingerLandscape, { autoAlpha: 0, duration: .34 }, 1.5);
        timeline.to(gingerHaze, { autoAlpha: 0, duration: .3 }, 1.5);
        timeline.to(strawberryProduct, { autoAlpha: 1, duration: .28 }, 1.42);
        timeline.to(strawberryProduct, { y: 0, scale: 1, filter: 'blur(0px)', duration: .42 }, 1.42);
        timeline.to(strawberryEyebrow, { autoAlpha: 1, y: 0, duration: .08 }, 1.49);
        timeline.to(strawberryTitle, { autoAlpha: 1, duration: .08 }, 1.5);
        timeline.to(strawberryTitle, { y: 0, clipPath: 'inset(0 0 0% 0)', duration: .13 }, 1.5);
        timeline.to(strawberryDescription, { autoAlpha: 1, y: 0, duration: .12 }, 1.57);
        timeline.to(strawberryTraits, { autoAlpha: 1, y: 0, duration: .1 }, 1.63);
        timeline.to(strawberryCta, { autoAlpha: 1, y: 0, duration: .1 }, 1.68);
        timeline.to(strawberryNotes, { autoAlpha: 1, duration: .11 }, 1.53);
        timeline.to(strawberryNoteParts, { autoAlpha: 1, y: 0, scale: 1, duration: .1, stagger: .025 }, 1.6);
        timeline.to([strawberryEyebrow, strawberryTitle, strawberryDescription, strawberryTraits, strawberryCta], { autoAlpha: 0, y: -12, duration: .12, stagger: .018 }, 2.35);
        timeline.to(strawberryProduct, { autoAlpha: 0, y: -20, scale: .98, filter: 'blur(2px)', duration: .3 }, 2.32);
        timeline.to(strawberryNoteParts, { autoAlpha: 0, y: -10, duration: .14, stagger: .025 }, 2.47);
        timeline.to(strawberryNotes, { autoAlpha: 0, duration: .13 }, 2.56);
        timeline.to(mintBackdrop, { autoAlpha: 1, duration: .38 }, 2.41);
        timeline.to(mintLandscape, { autoAlpha: 1, duration: .38 }, 2.41);
        timeline.to(mintHaze, { autoAlpha: 1, duration: .32 }, 2.44);
        timeline.to(strawberryBackdrop, { autoAlpha: 0, duration: .34 }, 2.5);
        timeline.to(strawberryLandscape, { autoAlpha: 0, duration: .34 }, 2.5);
        timeline.to(strawberryHaze, { autoAlpha: 0, duration: .3 }, 2.5);
        timeline.to(mintProduct, { autoAlpha: 1, duration: .28 }, 2.42);
        timeline.to(mintProduct, { y: 0, scale: 1, filter: 'blur(0px)', duration: .42 }, 2.42);
        timeline.to(mintEyebrow, { autoAlpha: 1, y: 0, duration: .08 }, 2.49);
        timeline.to(mintTitle, { autoAlpha: 1, duration: .08 }, 2.5);
        timeline.to(mintTitle, { y: 0, clipPath: 'inset(0 0 0% 0)', duration: .13 }, 2.5);
        timeline.to(mintDescription, { autoAlpha: 1, y: 0, duration: .12 }, 2.57);
        timeline.to(mintTraits, { autoAlpha: 1, y: 0, duration: .1 }, 2.63);
        timeline.to(mintCta, { autoAlpha: 1, y: 0, duration: .1 }, 2.68);
        timeline.to(mintNotes, { autoAlpha: 1, duration: .11 }, 2.53);
        timeline.to(mintNoteParts, { autoAlpha: 1, y: 0, scale: 1, duration: .1, stagger: .025 }, 2.6);
        // Mint stays in place before its can travels into the four-flavour group.
        timeline.to([mintEyebrow, mintTitle, mintDescription, mintTraits, mintCta], { autoAlpha: 0, y: -12, duration: .19, stagger: .018 }, 3.27);
        timeline.to(flavourNav, { autoAlpha: 0, duration: .22 }, 3.29);
        timeline.to(mintNoteParts, { autoAlpha: 0, y: -10, duration: .17, stagger: .02 }, 3.29);
        timeline.to(mintNotes, { autoAlpha: 0, duration: .16 }, 3.42);
        timeline.set(mintProduct, { autoAlpha: 0 }, 3.38);
        timeline.set(packMint, { autoAlpha: 1 }, 3.38);
        timeline.to(packMint, { left: '42.6%', top: '17%', height: '61%', x: 0, rotation: 0, duration: .52 }, 3.38);
        timeline.fromTo(packOriginal, { left: '15%', top: '17%', height: '61%', x: -85 }, { autoAlpha: 1, x: 0, y: 0, scale: 1, filter: 'blur(0px)', duration: .35 }, 3.48);
        timeline.fromTo(packGinger, { left: '24.2%', top: '17%', height: '61%', x: -60 }, { autoAlpha: 1, x: 0, y: 0, scale: 1, filter: 'blur(0px)', duration: .35 }, 3.57);
        timeline.fromTo(packStrawberry, { left: '33.4%', top: '17%', height: '61%', x: -40 }, { autoAlpha: 1, x: 0, y: 0, scale: 1, filter: 'blur(0px)', duration: .35 }, 3.66);
        timeline.to(packLandscape, { autoAlpha: 1, duration: .42 }, 3.52);
        timeline.to(packBoxes, { autoAlpha: 1, y: 0, duration: .48 }, 4.02);
        timeline.to(packCopy, { autoAlpha: 1, duration: .01 }, 4.37);
        timeline.to(packCopy.children[0], { autoAlpha: 1, y: 0, duration: .12 }, 4.38);
        timeline.to(packCopy.children[1], { autoAlpha: 1, y: 0, duration: .17 }, 4.43);
        timeline.to(packCopy.children[2], { autoAlpha: 1, y: 0, duration: .12 }, 4.57);
        timeline.to(packCopy.children[3], { autoAlpha: 1, y: 0, duration: .12 }, 4.63);
        timeline.to(packCopy.children[4], { autoAlpha: 1, y: 0, duration: .13 }, 4.70);
        // Let the complete pack settle before the pinned chapter releases.
        timeline.to([packCansGroup, ...packBoxes, packCopy], { scale: .97, y: 20, duration: .21 }, 5.02);
        timeline.to(packLandscape, { filter: 'brightness(.88) contrast(.97)', duration: .21 }, 5.02);
        scrollMotion = {
          goTo(flavour, smooth = true) {
            const trigger = timeline.scrollTrigger;
            if (!trigger) return;
            const span = trigger.end - trigger.start;
            const sceneTime = flavour === 'mint' ? 3.05 : flavour === 'strawberry' ? 2.05 : flavour === 'ginger' ? 1.05 : 0;
            const destination = trigger.start + span * sceneTime / sceneDuration;
            window.scrollTo({ top: destination, behavior: smooth ? 'smooth' : 'auto' });
          },
          goToPack(smooth = true) {
            const trigger = timeline.scrollTrigger;
            if (!trigger) return;
            window.scrollTo({ top: trigger.start + (trigger.end - trigger.start) * 4.93 / sceneDuration, behavior: smooth ? 'smooth' : 'auto' });
          },
        };
        if (fromLocation() !== 'original') requestAnimationFrame(() => scrollMotion?.goTo(fromLocation(), false));
        ScrollTrigger.sort();
        ScrollTrigger.refresh();
        if (location.hash === '#pack-decouverte') {
          // Native fragment scrolling can run after the pin has been measured.
          // Reapply the timeline position once the page has finished loading.
          const restorePackDeepLink = () => {
            if (location.hash === '#pack-decouverte') scrollMotion?.goToPack(false);
          };
          requestAnimationFrame(restorePackDeepLink);
          if (document.readyState === 'complete') setTimeout(restorePackDeepLink, 300);
          else addEventListener('load', () => setTimeout(restorePackDeepLink, 300), { once: true });
        }

        return () => {
          const flavour = activeFlavour;
          timeline.scrollTrigger?.kill();
          timeline.kill();
          gsap.set([landscape, haze, mateProduct, mateCan, mateShadow, ...mateCopyParts, ...mateNoteParts, gingerProduct, gingerAside, strawberryProduct, mintProduct, flavourNav, pack, packLandscape, ...packBoxes, packCansGroup, packCopy, ...packCopy.children, ...packCans], { clearProps: 'all' });
          gingerBackdrop.remove();
          gingerLandscape.remove();
          gingerHaze.remove();
          strawberryBackdrop.remove();
          strawberryLandscape.remove();
          strawberryHaze.remove();
          mintBackdrop.remove();
          mintLandscape.remove();
          mintHaze.remove();
          gingerCopy.remove();
          gingerNotes.remove();
          strawberryCopy.remove();
          strawberryNotes.remove();
          mintCopy.remove();
          mintNotes.remove();
          copy.removeAttribute('aria-hidden');
          notes.removeAttribute('aria-hidden');
          copy.style.pointerEvents = '';
          notes.style.pointerEvents = '';
          section.classList.remove('is-scroll-transition');
          scrollMotion = null;
          show(flavour);
        };
      });
      // Keep the mobile campaign in view while native scrolling advances its four photos.
      media.add('(max-width: 600px) and (prefers-reduced-motion: no-preference)', () => {
        const scene = get('.brio-flavours-master__scene');
        const landscape = get('.brio-flavours-master__landscape');
        const copy = get('.brio-flavours-master__copy');
        const pack = get('.brio-flavours-master__pack');
        if (!scene || !landscape || !copy || !pack) return;
        const headerHeight = () => document.querySelector('.brio-banner-header')?.getBoundingClientRect().height || 64;
        let previousPhoto = null;
        section.classList.add('is-mobile-scroll-pinned');

        const changeFlavour = (flavour) => {
          if (flavour === activeFlavour) return;
          if (previousPhoto) {
            gsap.killTweensOf(previousPhoto);
            previousPhoto.remove();
          }
          const current = getComputedStyle(landscape);
          previousPhoto = landscape.cloneNode(false);
          previousPhoto.setAttribute('aria-hidden', 'true');
          Object.assign(previousPhoto.style, {
            backgroundImage: current.backgroundImage,
            backgroundPosition: current.backgroundPosition,
            backgroundSize: current.backgroundSize,
            backgroundColor: current.backgroundColor,
            left: current.left,
            right: current.right,
            top: current.top,
            bottom: current.bottom,
            filter: current.filter,
            transform: current.transform,
            pointerEvents: 'none',
            opacity: '1',
          });
          landscape.after(previousPhoto);
          show(flavour);
          gsap.killTweensOf(copy);
          gsap.fromTo(copy, { opacity: .55, y: 7 }, { opacity: 1, y: 0, duration: .28, ease: 'power1.out' });
          const fadingPhoto = previousPhoto;
          gsap.to(fadingPhoto, { opacity: 0, duration: .32, ease: 'power1.out', onComplete: () => {
            fadingPhoto.remove();
            if (previousPhoto === fadingPhoto) previousPhoto = null;
          } });
        };

        const trigger = ScrollTrigger.create({
          trigger: scene,
          start: () => `top top+=${Math.round(headerHeight())}`,
          end: () => `+=${Math.round(scene.getBoundingClientRect().height * 5.6)}`,
          pin: true,
          pinSpacing: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          refreshPriority: 1,
          onUpdate: (self) => {
            const index = Math.min(3, Math.floor(self.progress * 4));
            changeFlavour(flavourOrder[index]);
          },
        });
        // Give the next chapter its own scroll distance. On touch screens a fast
        // release at the end of 04 otherwise carries momentum straight past it.
        const packHold = ScrollTrigger.create({
          trigger: pack,
          start: () => `top top+=${Math.round(headerHeight())}`,
          end: () => `+=${Math.round(Math.max(pack.getBoundingClientRect().height, window.innerHeight - headerHeight()) * 1.8)}`,
          pin: true,
          pinSpacing: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        });
        mobileScrollMotion = {
          goTo(flavour, smooth = true) {
            const index = flavourOrder.indexOf(flavour);
            if (index < 0) return;
            const destination = trigger.start + (trigger.end - trigger.start) * (index + .5) / 4;
            window.scrollTo({ top: destination, behavior: smooth ? 'smooth' : 'auto' });
          },
          goToPack(smooth = true) {
            window.scrollTo({ top: packHold.start, behavior: smooth ? 'smooth' : 'auto' });
          },
        };
        if (fromLocation() !== 'original') requestAnimationFrame(() => mobileScrollMotion?.goTo(fromLocation(), false));
        if (location.hash === '#pack-decouverte') requestAnimationFrame(() => mobileScrollMotion?.goToPack(false));
        ScrollTrigger.sort();
        ScrollTrigger.refresh();

        return () => {
          packHold.kill();
          trigger.kill();
          if (previousPhoto) {
            gsap.killTweensOf(previousPhoto);
            previousPhoto.remove();
          }
          gsap.killTweensOf(copy);
          gsap.set(copy, { clearProps: 'opacity,visibility,transform' });
          section.classList.remove('is-mobile-scroll-pinned');
          mobileScrollMotion = null;
        };
      });
      // Tablets keep direct flavour selection and normal page scrolling.
      media.add('(max-width: 850px) and (prefers-reduced-motion: no-preference)', () => {
        const pack = get('.brio-flavours-master__pack');
        if (!pack) return;
        const cans = [...pack.querySelectorAll('.brio-flavours-master__pack-can')];
        const boxes = [...pack.querySelectorAll('.brio-flavours-master__pack-box')];
        const copy = pack.querySelector('.brio-flavours-master__pack-copy');
        gsap.set(cans, { autoAlpha: 0, y: 22 });
        gsap.set(boxes, { autoAlpha: 0, y: 100 });
        gsap.set(copy, { autoAlpha: 0, y: 15 });
        const reveal = gsap.timeline({ paused: true, defaults: { ease: 'power3.out' } });
        reveal.to(cans, { autoAlpha: 1, y: 0, duration: .42, stagger: .055 })
          .to(boxes, { autoAlpha: 1, y: 0, duration: .5 }, '-=.08')
          .to(copy, { autoAlpha: 1, y: 0, duration: .32 }, '-=.18');
        const trigger = ScrollTrigger.create({ trigger: pack, start: 'top 85%', once: true, onEnter: () => reveal.play() });
        return () => {
          trigger.kill();
          reveal.kill();
          gsap.set([...cans, ...boxes, copy], { clearProps: 'all' });
        };
      });
    };
    navLinks.forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      const flavour = link.dataset.brioFlavour;
      if (scrollMotion) scrollMotion.goTo(flavour);
      else show(flavour);
      const url = new URL(location.href);
      if (flavour === 'ginger' || flavour === 'strawberry' || flavour === 'mint') url.searchParams.set('brio_flavour', flavour); else url.searchParams.delete('brio_flavour');
      url.hash = 'saveurs';
      history.pushState({}, '', url);
    }));
    const selectMobileFlavour = (flavour, historyMethod = null) => {
      if (!flavourOrder.includes(flavour) || flavour === activeFlavour) return;
      show(flavour);
      if (!historyMethod) return;
      const url = new URL(location.href);
      if (flavour === 'original') url.searchParams.delete('brio_flavour');
      else url.searchParams.set('brio_flavour', flavour);
      url.hash = 'saveurs';
      history[historyMethod]({}, '', url);
    };
    mobileButtons.forEach((button) => button.addEventListener('click', () => {
      const flavour = button.dataset.brioMobileFlavour;
      if (mobileScrollMotion) mobileScrollMotion.goTo(flavour);
      else selectMobileFlavour(flavour, 'pushState');
    }));
    document.querySelectorAll('a[href*="#pack-decouverte"]').forEach((link) => link.addEventListener('click', (event) => {
      if (mobileScrollMotion) {
        event.preventDefault();
        mobileScrollMotion.goToPack();
        return;
      }
      if (!scrollMotion) return;
      event.preventDefault();
      scrollMotion.goToPack();
      const url = new URL(location.href);
      url.hash = 'pack-decouverte';
      history.pushState({}, '', url);
    }));
    addEventListener('popstate', () => {
      if (mobileScrollMotion && location.hash === '#pack-decouverte') mobileScrollMotion.goToPack();
      else if (mobileScrollMotion) mobileScrollMotion.goTo(fromLocation(), false);
      else if (scrollMotion && location.hash === '#pack-decouverte') scrollMotion.goToPack(false);
      else if (scrollMotion) scrollMotion.goTo(fromLocation(), false);
      else show(fromLocation());
    });
    show(fromLocation());
    setupScrollMotion();
  };

  const setupMateReveal = (section) => {
    if (!section || section.dataset.mateRevealReady) return;
    section.dataset.mateRevealReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const notes = section.querySelector('.brio-flavours-master__notes');
    const can = section.querySelector('.brio-flavours-master__can');
    if (reducedMotion.matches || !('IntersectionObserver' in window) || !notes || !can || section.classList.contains('is-ginger') || section.classList.contains('is-strawberry') || section.classList.contains('is-mint') || section.classList.contains('is-scroll-transition')) return;

    section.classList.add('is-can-motion-ready');
    notes.classList.add('is-notes-motion-ready');

    const canObserver = new IntersectionObserver((entries, observer) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      section.classList.add('is-can-motion-visible');
      observer.disconnect();
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

    const notesObserver = new IntersectionObserver((entries, observer) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      notes.classList.add('is-notes-motion-visible');
      observer.disconnect();
    }, { threshold: 0.12 });

    // Give the initial styles a frame before starting an already-visible anchor target.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      canObserver.observe(can);
      notesObserver.observe(notes);
    }));

    reducedMotion.addEventListener?.('change', () => {
      if (!reducedMotion.matches) return;
      section.classList.add('is-can-motion-visible');
      notes.classList.add('is-notes-motion-visible');
      canObserver.disconnect();
      notesObserver.disconnect();
    }, { once: true });
  };

  const setup = (root = document) => {
    const sections = root.matches?.('.brio-flavours-master') ? [root] : [...(root.querySelectorAll?.('.brio-flavours-master') || [])];
    sections.forEach((section) => { setupFlavours(section); setupMateReveal(section); });
  };

  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
